import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=1e2fd28f&"
import script from "./VIcon.vue?vue&type=script&lang=js&"
export * from "./VIcon.vue?vue&type=script&lang=js&"
import style0 from "./VIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2fd28f')) {
      api.createRecord('1e2fd28f', component.options)
    } else {
      api.reload('1e2fd28f', component.options)
    }
    module.hot.accept("./VIcon.vue?vue&type=template&id=1e2fd28f&", function () {
      api.rerender('1e2fd28f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VIcon.vue"
export default component.exports